import { number, string } from "prop-types";
import { useMemo } from "react";

import { useFormatCurrency } from "@krea/customer-features/hooks";
import EditIcon from "@krea/customer-features/images/svg/guarantor-edit.svg";
import TrashIcon from "@krea/customer-features/images/svg/trash.svg";
import { settings } from "@krea/customer-features/settings";
import FileSection from "@krea/customer-features/shared-components/fields/file-section";
import FileSectionAction from "@krea/customer-features/shared-components/fields/file-section/FileSectionAction";

const RefinancingAmountItem = ({
  lenderName,
  outstandingAmount,
  monthlyCost,
  onEdit,
  onRemove,
  isPreviewMode,
  t,
}) => {
  const currency = settings.currency;
  const [formattedCurrencyValue] = useFormatCurrency({ currency });

  const content = useMemo(() => {
    let contentArray = [];

    if (outstandingAmount) {
      contentArray.push(
        `${t("iaq.refinancingAmounts.outstandingAmountLabel")}: ${formattedCurrencyValue(outstandingAmount)}`,
      );
    }

    if (monthlyCost) {
      contentArray.push(
        `${t("iaq.refinancingAmounts.monthlyCostLabel")}: ${formattedCurrencyValue(monthlyCost)}`,
      );
    }

    return contentArray;
  }, [formattedCurrencyValue, monthlyCost, outstandingAmount, t]);

  return (
    <>
      {isPreviewMode ? (
        <div className="d-flex align-items-start mt-2">
          <div className="pl-2 w-100">
            <div className="d-inline-block mr-2">#{lenderName}</div>
          </div>
        </div>
      ) : (
        <FileSection
          variant="user"
          title={lenderName}
          contentList={content}
          actions={
            <>
              <FileSectionAction
                title={t("commons.edit")}
                icon={EditIcon}
                iconClassName={"tw-w-[20px] tw-h-[20px]"}
                onClick={onEdit}
              />
              <FileSectionAction
                title={t("commons.delete")}
                icon={TrashIcon}
                onClick={onRemove}
              />
            </>
          }
        />
      )}
    </>
  );
};

RefinancingAmountItem.propTypes = {
  lenderName: string,
  outstandingAmount: number,
  monthlyCost: number,
};

export default RefinancingAmountItem;
